var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card pa-8"},[_c('div',[_c('h3',{staticStyle:{"font-size":"42px","font-weight":"700"}},[_vm._v(_vm._s(_vm.year))]),_c('h4',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.title))])]),_c('v-spacer'),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.link))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }